import React from "react";
import About_Banner from "./about-banner/About_Banner";
import Vision_Mission_Value from "./vision-mission-value/Vision_Mission_Value";
import Why_Choose_Us from "./why_choose_us/Why_Choose_Us";
import Power_Progress from "../home/power-progress/Power_Progress";
import Man_Behind_The_Power from "./man_behind_the_power/Man_Behind_The_Power";
import PeopleBehindWork from "./people-behind-work/People_Behind_Work";
import WhyWeRankAmongTopSolar from "./why-we-rank-among-top-solar/Why_We_Rank_Among_Top_Solar";
import Free_Consultation from "../home/free-consultation/Free_Consultation";
import Tier1_Trusted_Brand from "./tier1-trusted-brand/Tier1_Trusted_Brand";
import WhatMakesHindustanDifferent from "./what-makes-hindustan-solar-different/What_Makes_Hindustan_Different";
import What_Customer_Say from "../home/what-customer-say/What_Customer_Say";

const About_Us = () => {
  return (
    <>
      <About_Banner />
      <Vision_Mission_Value />
      <Why_Choose_Us />
      <Man_Behind_The_Power />
      <Power_Progress />
      <Free_Consultation />
      <PeopleBehindWork />
      <WhyWeRankAmongTopSolar />
      <WhatMakesHindustanDifferent/>
      <Tier1_Trusted_Brand/>
      <What_Customer_Say/>
    </>
  );
};

export default About_Us;
